<template>
  <div class="container-fluid content-pad content-pad--big-top">
    <div class="content-wrap-x-small">
      <dx-progressbar
        :steps="4"
        :active-step="3"
        is-interactive
        @jump-to-step="jumpToStep"
      />
    </div>
    <div class="row mt-5">
      <div class="col-12 col-md-8">
        <h3>{{ $t('offer.questions.headline') }}</h3>
        <p>{{ $t('offer.questions.sub') }}</p>

        <dx-assessment-questions
          ref="assessmentQuestionsForm"
          editable
          @change="
            () => {
              hasChanged = true
            }
          "
        />

        <dx-bottom-bar
          :is-sticky="false"
          show-previous-button
          class="mt-5"
          @back="goBack"
          @forward="goForward"
        />
      </div>
      <div class="col-12 col-md-4 d-none d-md-block">
        <dx-sticky-price-container
          :selected-tariff="activeTariff"
          :price="premia.totalPremium.value"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DxProgressbar from '~/components/DX-Progressbar'
import DxBottomBar from '~/components/DX-BottomBar'
import DxAssessmentQuestions from '~/components/offer/DX-AssessmentQuestions'
import DxStickyPriceContainer from '~/domains/partnerPortal/components/DX-StickyPriceContainer'
import scrollFirstErrorIntoView from '~/javascripts/helper/scollIntoView'

export default {
  name: 'OfferQuestions',
  components: {
    DxProgressbar,
    DxBottomBar,
    DxStickyPriceContainer,
    DxAssessmentQuestions,
  },
  layout: 'website',
  // maybe use a dynamic layout here some day?
  // layout: ({ store }) => (store.getters.isLoggedIn ? 'default' : 'website'),
  data() {
    return {
      premia: this.$store.state.offer.premia,
      activeTariff: this.$store.state.offer.activeTariff,
    }
  },
  methods: {
    goBack() {
      this.$refs.assessmentQuestionsForm.saveForm(true)
      this.$router.push({ path: this.localePath('Offer-PolicyholderData') })
    },
    jumpToStep(stepNumber) {
      if (stepNumber === 1) {
        const introPath = this.$store.getters.GET_OFFER_INTRO_PATH
        this.$refs.assessmentQuestionsForm.saveForm(true)
        this.$router.push({ path: this.localePath(introPath) })
      } else if (stepNumber === 2) {
        this.goBack()
      }
    },
    async goForward() {
      const valid = await this.$refs.assessmentQuestionsForm.saveForm()
      if (valid) {
        this.$store.commit('SET_STEP', 4)
        this.$router.push({ path: this.localePath('Offer-Summary') })
      } else {
        await scrollFirstErrorIntoView()
      }
    },
  },
  meta: {
    isPublic: true,
    trackingId: 'dextra.rechtsschutz-antragsstrecke.unsere-fragen',
    offerStep: 3,
  },
  nuxtI18n: {
    paths: {
      de: '/rechtsschutz-antragsstrecke/unsere-fragen/',
      fr: '/protection-juridique-formulaire-de-demande/nos-questions/',
    },
  },
}
</script>
